import { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ROUTE_PATHS } from 'routes';
import { color, theme } from 'constants/styled-theme';
import Tab from './tab';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 50px;
  overflow: auto;
  z-index: 10;
  background: ${color('backgroundMenuColor')};
  width: 100%;
`;

const Tabs = styled.div`
  display: flex;
  background: ${color('backgroundMenuColor')};
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: 100;
  overflow: auto;
  @media (max-width: ${p => p.theme.mobile}) {
    justify-content: flex-start;
    width: 100%;
  }
`;

const FaqTabBar = ({ onMouseLeave }) => {
  const tabsRef = useRef(null);
  const isMobile = window.matchMedia(`(max-width:${theme.mobile})`).matches;
  const scrollToRef = ref => {
    if (isMobile) {
      tabsRef.current.scrollTo({
        top: 0,
        left: ref.current.offsetLeft - 50,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Header onMouseLeave={onMouseLeave}>
      <Tabs ref={tabsRef}>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.FAQ}>
          FAQ
        </Tab>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.HOW_IT_WORKS}>
          How it Works
        </Tab>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.TERMS_AND_CONDITIONS}>
          Terms and conditions
        </Tab>
      </Tabs>
    </Header>
  );
};
export default FaqTabBar;

FaqTabBar.propTypes = {
  onMouseLeave: PropTypes.func
};
